import { render, staticRenderFns } from "./PopupAIImageRiskRecommendation.vue?vue&type=template&id=53ba40c3&scoped=true"
import script from "./PopupAIImageRiskRecommendation.vue?vue&type=script&lang=js"
export * from "./PopupAIImageRiskRecommendation.vue?vue&type=script&lang=js"
import style0 from "./PopupAIImageRiskRecommendation.vue?vue&type=style&index=0&id=53ba40c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ba40c3",
  null
  
)

export default component.exports